// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore";
import {getAnalytics} from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAlyiCDg09iQH45xixPKaP79ujxco8IB9Q",
    authDomain: "website-f2b7e.firebaseapp.com",
    projectId: "website-f2b7e",
    storageBucket: "website-f2b7e.appspot.com",
    messagingSenderId: "751405738544",
    appId: "1:751405738544:web:ff6fb6464288a941419bf5",
    measurementId: "G-LHRVVM7G65"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

export {app, db, analytics};
